import { useState, useEffect } from 'react';
import userClient from '../utils/apiClients/userClient';

const useUserDetails = () => {
  const [user, setUser] = useState(() => {
    const cachedUser = sessionStorage.getItem('userProfile');
    return cachedUser ? JSON.parse(cachedUser) : { givenName: '', familyName: '' };
  });
  const [isLoading, setLoading] = useState(!user.givenName);

  useEffect(() => {
    if (user.givenName) return;
    const getUser = async () => {
      try {
        const { data: userInfo } = await userClient.get('users/me');
        const userData = {
          givenName: userInfo?.givenName,
          familyName: userInfo?.familyName
        };
        setUser(userData);
        sessionStorage.setItem('userProfile', JSON.stringify(userData));
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { user, isLoading };
};
export default useUserDetails;
